<agpr-take-over-panel
    #takeOverPanel
    id="adHocAgentManagementPanel"
    class="agpr-adHocAgentManagement"
    header="AutomationAgents.adHoc.management.title"
    headerIcon="fa-kit-duotone fa-agpr-ai-generic"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="960"
    [maxPanelWidth]="1400"
    [fullHeight]="true"
    footerContext="AutomationAgents.adHoc.management.title"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="agpr-adHocAgentManagement-body" [agprLoading]="loading">
        <!-- One type of agent so far, drawn the way the agent list draws its own tab row -->
        <agpr-tabs
            class="agpr-adHocAgentManagement-tabs"
            [selectedTabIndex]="0"
            [useContentContainer]="false"
        >
            <agpr-tab
                id="adHocAgentManagementPanel_curationTab"
                heading="AutomationAgents.tab.curation"
            ></agpr-tab>
        </agpr-tabs>

        <!-- The shared pair: the filter button opens the filter widget, with everything filtered by
             listed beside it -->
        <div class="agpr-adHocAgentManagement-filters">
            <agpr-filter-dropdown
                id="adHocAgentManagementPanel.filters"
                class="agpr-adHocAgentManagement-filterButton"
                tooltip="AutomationAgents.adHoc.management.filter"
            ></agpr-filter-dropdown>

            <agpr-filter-chips
                id="adHocAgentManagementPanel.filterChips"
                class="agpr-adHocAgentManagement-filterChips"
                emptyMessage="AutomationAgents.adHoc.management.filter.none"
            ></agpr-filter-chips>
        </div>

        <agpr-table
            id="adHocAgentManagementPanel.runs"
            class="agpr-adHocAgentManagement-table"
            [columns]="columns"
            [sortColumn]="startedColumn"
            [sortAscending]="false"
            [enableSelectAll]="false"
            [vsItemSize]="45"
            [vsMinBufferPx]="400"
            [vsMaxBufferPx]="800"
            noContentMessage="AutomationAgents.agent.dashboard.adHocHistory.empty"
            [(ngModel)]="rows"
        ></agpr-table>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            id="adHocAgentManagementPanel.cancel"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="close()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<!-- A run still working has nothing to report on yet, so it carries no control -->
<ng-template #actionsCell let-row="row">
    @if (row.isComplete) {
        <agpr-button
            [id]="'adHocAgentManagementPanel_run_' + row.run.id + '_viewReport'"
            [style]="buttonTypes.icon"
            icon="fa-regular fa-duotone fa-eye"
            tooltip="AutomationAgents.agent.dashboard.adHoc.viewReport"
            tooltipPosition="left"
            [ariaLabel]="'AutomationAgents.agent.dashboard.adHoc.viewReport' | localize"
            (click)="viewReport(row)"
        ></agpr-button>
    }
</ng-template>

<!-- The agent opens in its own tab, so the panel is left as it was -->
<ng-template #agentCell let-row="row">
    <a
        class="agpr-adHocAgentManagement-link agpr-adHocAgentManagement-agent"
        [href]="row.agentUrl"
        target="_blank"
        rel="noopener"
        [pTooltip]="row.agentName"
        tooltipPosition="top"
    >{{ row.agentName }}</a>
</ng-template>

<!-- A run submitted from a query or a list of mentions has no source to open -->
<ng-template #sourceCell let-row="row">
    <span class="agpr-adHocAgentManagement-source">
        <span
            class="agpr-adHocAgentManagement-sourceIcon"
            [ngClass]="row.sourceIcon"
            [agprTooltip]="row.sourceTypeLabel | localize"
            tooltipPosition="top"
            [attr.aria-label]="row.sourceTypeLabel | localize"
        ></span>
        @if (row.canViewSource) {
            <button
                class="agpr-adHocAgentManagement-link"
                [agprTooltip]="'AutomationAgents.card.source.view' | localize"
                tooltipPosition="top"
                (click)="viewSource(row)"
            >{{ row.sourceName }}</button>
        } @else {
            <span>{{ row.sourceName }}</span>
        }
    </span>
</ng-template>
